module.exports = __webpack_public_path__ + "img/logo_afeshop.06f0b460.png";